import { Stack, Typography, Avatar, Divider, Link } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { NoDataFoundImage2 } from 'Images';
import React, { Fragment } from 'react';

interface IRedirect {
  text: string;
  href: string;
}

interface INoDataFound2 {
  redirects?: IRedirect[];
  gap?: string;
  redirectsComponent?: React.ReactNode;
  headerComponent?: React.ReactNode;
  offerExtraText?: boolean;
  extraText?: string;
  footerComponent?: React.ReactNode;
  image?: string;
}

export const NoDataFound2 = ({
  redirects,
  gap,
  headerComponent,
  redirectsComponent,
  offerExtraText = true,
  extraText,
  footerComponent,
  image,
}: INoDataFound2) => {
  const isDesktop = useIsDesktop();

  return (
    <Stack alignItems={'center'} gap={gap}>
      {headerComponent && headerComponent}
      <Avatar
        sx={{
          width: isDesktop ? 'fit-content' : '180px',
          height: isDesktop ? '333.75px' : '150px',
        }}
        src={image ? image : NoDataFoundImage2}
        alt={Dictionary[DICTIONARY.General].noDataFound}
      />
      <Stack alignItems={'center'} gap={isDesktop ? '16px' : '12px'}>
        {offerExtraText && (
          <Typography
            component='h2'
            variant='h5'
            color='text.secondary'
            textAlign='center'
          >
            {extraText ? extraText : Dictionary[DICTIONARY.General].noDataOffer}
          </Typography>
        )}
        <Stack
          direction='row'
          flexWrap='wrap'
          alignItems='center'
          justifyContent='center'
          gap='16px'
          width='auto'
          maxWidth={isDesktop ? '70%' : '90%'}
        >
          {redirects &&
            redirects.map((redirect, index) => (
              <Fragment key={index}>
                <Link underline='always' href={redirect.href}>
                  <Typography variant='body3'>{redirect.text}</Typography>
                </Link>
                {isDesktop ? (
                  index !== redirects.length - 1 ? (
                    <Divider
                      sx={{ height: '22px', borderColor: '#1752AF' }}
                      aria-hidden='true'
                      orientation='vertical'
                    />
                  ) : null
                ) : index === 0 ? (
                  <Divider
                    sx={{ height: '22px', borderColor: '#1752AF' }}
                    aria-hidden='true'
                    orientation='vertical'
                  />
                ) : null}
              </Fragment>
            ))}
          {redirectsComponent && redirectsComponent}
          {footerComponent}
        </Stack>
      </Stack>
    </Stack>
  );
};
